const VoucherProgramsListResources = {
    headerVoucherPrograms: 'Voucher Programs',
    programName: 'program name',
    headerActions: 'Actions',
    labelView: 'View',
    labelEdit: 'Edit',
    addVoucherProgramButtonText: 'Add Voucher Program'
};
export default VoucherProgramsListResources;
